import { KeyRound } from 'lucide-react';

import { CabinetsRolesCard } from 'back-office/features/plateformes-view/CabinetsRolesCard';

/**
 * Portail Plateforme : rôles des courtiers de MON plateforme. Même carte que
 * l'onglet Rôles de la fiche plateforme admin, en mode gouvernance — la liste
 * et l'édition sont scopées serveur sur la plateforme active de l'appelant, et
 * le plafond délégable borne ce qui peut être accordé.
 */
export default function RolesCourtiersPage() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold text-zinc-800 flex items-center gap-3">
        <KeyRound className="text-primary w-6 h-6" />
        Rôles des courtiers
      </h1>
      <p className="mb-6 mt-1 text-sm text-gray-500">
        Les rôles de chaque courtier dans votre plateforme : hérités de son compte, ou propres à
        la plateforme quand vous les ajustez — dans la limite des briques délégables fixées par
        l'administrateur.
      </p>
      <CabinetsRolesCard />
    </div>
  );
}
